export const theme = {
  header: {
    p: 1,
    bgcolor: 'text.primary',
    position: 'relative',
  },
  companyName: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: 'auto',
    height: '65px',
  },
  langContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};
